var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-base',{attrs:{"filter-key":_vm.filterKey,"index":_vm.index}},[_c('span',{staticClass:"pl-6"},[_vm._v(" "+_vm._s(_vm.config.displayName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }